import React from 'react';
import { TraderTimeProvider } from '../contexts/TraderTimeContext';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { cabinetPath } from '../lib/domains';
import { Loader2 } from 'lucide-react';

interface TraderProtectedRouteProps {
    children: React.ReactNode;
}

export const TraderProtectedRoute: React.FC<TraderProtectedRouteProps> = ({ children }) => {
    const { isAuthenticated, userType, isLoading, user } = useAuth();
    const location = useLocation();

    // Показываем загрузку пока проверяем аутентификацию
    if (isLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="text-center">
                    <Loader2 className="h-8 w-8 animate-spin mx-auto mb-2" />
                    <p className="text-muted-foreground">Загрузка...</p>
                </div>
            </div>
        );
    }

    // Если пользователь не авторизован, перенаправляем на страницу входа трейдера
    if (!isAuthenticated) {
        return <Navigate to={cabinetPath('trader', '/login')} state={{ from: location }} replace />;
    }

    // Если авторизован, но не как трейдер, перенаправляем на главную
    if (userType !== 'trader') {
        return <Navigate to="/" replace />;
    }

    // Если трейдер авторизован, показываем защищенный контент
    return <TraderTimeProvider key={user?.id}>{children}</TraderTimeProvider>;
};
